import React, { useEffect, useRef } from 'react';
import { styled } from '@glitz/react';
import { Sort12x12 } from 'Shared/Icons/Sort';
import { Unchecked16x16, Checked16x16 } from 'Shared/Icons/Radio';
import { ButtonHeight, ButtonTheme, SolidButton } from 'Shared/TextButtons';
import Select from 'Shared/Fields/Select.type';
import * as style from 'Shared/Style';
import { pseudo } from '@glitz/core';

const SortWrap = styled.div({
  position: 'relative',
})

const Radio = styled(Unchecked16x16, {
  marginRight: '8px',
});

const RadioChecked = styled(Checked16x16, {
  marginRight: '8px',
});

const SortOptions = styled.form({
  display: 'flex',
  position: 'absolute',
  backgroundColor: style.colors.monochrome.extraLightGrey,
  borderRadius: '8px',
  right: 'calc(-100% - 100px)',
  zIndex: 20,
  flexFlow: 'column',
  overflow: 'hidden',
  ...style.transition({ property: 'right', duration: '300ms', timingFunction: 'ease-out' }),
  marginTop: '8px',
  padding: {
    xy: '12px',
  },

  ['@media ' + style.mediaMinLarge]: {
    marginTop: '12px',
    padding: {
      xy: '16px',
    },
  },
});

const SortOption = styled.input({
  position: 'relative',
  display: 'inline-block',
  appearance: 'none',
});

const SortLabel = styled.label({
  display: 'flex',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  alignItems: 'center',
  marginBottom: '12px',

  ['@media ' + style.mediaMinLarge]: {
    marginBottom: '8px',
  },

  ...pseudo(':last-child', {
    marginBottom: '0px',
  }),
});

const ButtonIcon = styled(Sort12x12, {
  marginLeft: '8px'
})

type ProductSortProps = {
  handleChange?: Function;
  toggleModal?: () => void;
  label: string;
  selected?: string;
  sort: Select;
  showModal?: boolean;
  isMobile: boolean;
};

const ProductSort = (props: ProductSortProps) => {
  const { label, sort, handleChange = () => { }, toggleModal = () => { }, showModal = false, selected, isMobile } = props;
  const modalRef = useRef<any>(null)
  const sortRef = useRef<any>(null)
  useEffect(() => {
    if (!showModal) {
      return () => { }
    }

    const handleClickEvent = (e: MouseEvent) => {
      if (modalRef.current) {
        const isClickInsideSort = modalRef.current.contains(e.target)
        if (!isClickInsideSort) {
          toggleModal();
        }
      }
    }

    window.addEventListener("click", handleClickEvent);
    return () => {
      window.removeEventListener("click", handleClickEvent);
    }
  }, [showModal])

  return (
    <SortWrap ref={modalRef}>
      <SolidButton
        theme={ButtonTheme.WhiteToBlack}
        text={label}
        iconAfter={<ButtonIcon />}
        onClick={() => { toggleModal(); }}
        height={ButtonHeight.Filter}
        padding={{ x: isMobile ? 12 : 24 }}
      />
      <SortOptions
        css={{
          ...(showModal && {
            right: '0px',
          }),
        }}

        onSubmit={(e) => {
          return false;
        }}
        onChange={(e) => {
          handleChange(e?.target);
        }}
        ref={sortRef}
      >
        {sort.options.map((opt, idx) => {
          return (
            <SortLabel key={idx}>
              <SortOption type="radio" name="ProductSort" value={opt.value} />
              {opt.value === selected && <RadioChecked />}
              {opt.value !== selected && <Radio />}
              {opt.text}
            </SortLabel>
          );
        })}
      </SortOptions>
    </SortWrap>
  );
};

export default ProductSort;
